import { useTranslation } from "react-i18next";
import { I18nProvider } from "@refinedev/core";
import "@utils/i18n";

export function getI18nProvider() {
    const { t, i18n } = useTranslation();

    const i18nProvider: I18nProvider = {
        translate: (key: string, options?: any, defaultMessage?: string) => {
            const tOptions = defaultMessage
                ? { ...(options || {}), defaultValue: defaultMessage }
                : options;
            return t(key, tOptions) as string;
        },
        changeLocale: (lang: string) => i18n.changeLanguage(lang),
        getLocale: () => i18n.language,
    };

    
    return i18nProvider;
}
